// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rm-6";
export var imgContainer = "_rm-3";
export var menuIcon = "_rm-5";
export var pillWrapper = "_rm-2";
export var pillsContainer = "_rm-1";
export var subscriptionCard = "_rm-0";
export var subscriptionLogo = "_rm-4";